import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from '@env'
import { registerGlobalIcons } from '@core/utils/icons.utils'

if (environment.production) {
  enableProdMode()
}

registerGlobalIcons()

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error('[BOOTSTRAP][ERROR]', err))
